import React from 'react';
import { Card, Nav } from 'react-bootstrap';
import classNames from 'classnames';
import NavItemPill from './NavItemPill';

/**
 * @component WizardHeader
 * @description Encabezado del wizard con los pasos de navegación.
 *
 * @param {string} variant - Variante de navegación (ej. 'pills').
 * @param {number} step - Paso actual del wizard.
 * @param {Array} steps - Arreglo de objetos que representan los pasos, con propiedades: label, icon, sectionDesc.
 *
 * @returns {JSX.Element}
 */
const LayoutHeader = ({ variant, step, steps }) => (
	<Card.Header className={classNames('bg-light', { 'px-4 py-3': variant === 'pills' })}>
		<Nav className="justify-content-center" variant={variant}>
			{steps.map((item, index) => (
				<NavItemPill
					key={`${item.label}-${index}`}
					index={index + 1}
					step={step}
					icon={item.icon}
					label={item.label}
					sectionDesc={item.sectionDesc}
				/>
			))}
		</Nav>
	</Card.Header>
);

export default LayoutHeader;